module.exports = __webpack_public_path__ + "img/features-audio.51d0da9d.svg";